var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "function-btns-container" },
    [
      _c(
        "div",
        {
          staticClass: "undo-wrapper",
          on: {
            mousedown: () => _vm.undoStartHandler("mousedown"),
            mouseup: () => _vm.undoEndHandler("mouseup"),
            touchstart: () => _vm.undoStartHandler("touchstart"),
            touchend: () => _vm.undoEndHandler("touchEnd"),
          },
        },
        [
          _c("img", {
            staticClass: "undo",
            attrs: { src: require("@/assets/svg/btns/undo.svg") },
          }),
          _c("span", { staticClass: "undo-label" }, [
            _vm._v(_vm._s(_vm.$t("Undo"))),
          ]),
        ]
      ),
      _c("Chip", { attrs: { chipValue: _vm.chips[0], disabled: false } }, [
        _c("img", { attrs: { src: require("@/assets/svg/chips/blue.svg") } }),
      ]),
      _c("Chip", { attrs: { chipValue: _vm.chips[1], disabled: false } }, [
        _c("img", { attrs: { src: require("@/assets/svg/chips/orange.svg") } }),
      ]),
      _c("Chip", { attrs: { chipValue: _vm.chips[2], disabled: false } }, [
        _c("img", { attrs: { src: require("@/assets/svg/chips/black.svg") } }),
      ]),
      _c("Chip", { attrs: { chipValue: _vm.chips[3], disabled: false } }, [
        _c("img", { attrs: { src: require("@/assets/svg/chips/purple.svg") } }),
      ]),
      _c("CustomChip"),
      _c(
        "div",
        {
          staticClass: "bet-btn-wrapper",
          class: { disabled: _vm.submitting || _vm.nobets },
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.submitBetHandler.apply(null, arguments)
            },
          },
        },
        [
          _c("img", {
            staticClass: "bet-btn-bg",
            attrs: { src: require("@/assets/images/bet_bg.png") },
          }),
          _c("img", {
            staticClass: "bet-btn-rotate",
            attrs: { src: require("@/assets/svg/btns/bet_rotate.svg") },
          }),
          _c(
            "div",
            { staticClass: "bet-btn-text", class: _vm.config.language },
            [_vm._v(" " + _vm._s(_vm.$t("Bet")) + " ")]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }